// extracted by mini-css-extract-plugin
module.exports = {"page-render-wrap":"index_page-render-wrap__2sLqK","page-render-progress":"index_page-render-progress__ROdfS"};